module.exports = __webpack_public_path__ + "img/EXTERIOR-BALENO-3.8464af86.jpg";